module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ca-102b45b24a03abdaeae6cf78eb470b12.svg";